<!--
	UserProfile.svelte
-->

<script>
    import { onMount } from 'svelte';
    import { isShowingUserProfile } from '../../stores/ScreenSettingsStore.js';
    import { getUserInitials, delimitArray } from '../../common/utils.js';
    import { signOut } from '../../common/auth.js';
    import { fly, fade, slide } from 'svelte/transition';

    // TCARE components

    // SMUI components
    import List, { Item, Separator } from '@smui/list';
    import {AccountStore} from "../../common/account";

    export let user;                    // passed in from UserAvatar - not from userStore
    $: user = $AccountStore;            // Vito
    
    onMount(() => {
    })

    const onProfileClick = () => {
        $isShowingUserProfile = false;
    }

	const onLogOutClick = () => {
        $isShowingUserProfile = false;
        signOut();
	}

</script>

<style>
    .user-profile {
        position: fixed;
        width: 350px;
        top: 35px;
        right: 45px;
        padding: 10px;
        color: var(--tcare-primary);
        font-size: 1.5em;
        background-color: white;
        box-shadow: 1px 1px 1px gray;
        border-radius: 5px;
        user-select: none;
    }

    .initials-block {
        width: 50px;
        height: 50px;
        margin-right: 20px;
        color: var(--tcare-white);
        font-size: 1em;
        background-color: var(--tcare-primary);
        border-radius: 50%;
    }

    .info-block {
        width: 200px;
        /* border: 1px solid red; */
    }

    .info-block div {
        padding: 2px;
    }

    .profile-row {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: .25em;
    }

    .user-profile .name {
        font-size: .9em;
    }

    .user-profile .username {
        font-size: .7em;
    }

    .user-profile .roles {
        margin-top: 10px;
        font-size: .6em;
        opacity: .8;
    }

    .user-profile .roles-list {
        margin-left: 20px;
        margin-bottom: 20px;
        font-size: .6em;
        font-weight: bold;
        opacity: .8;
    }

    .user-profile .log-out {
        width: 100%;
        padding-top: 10px;
        font-size: .7em;
    }

    .log-out:hover {
        color: var(--tcare-secondary);
    }

    @media screen and (max-width: 600px) {
        .user-profile {
            width: 90%;
            top: 30px;
            right: 5%;
        }
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="user-profile" 
    on:click={onProfileClick}
    in:slide="{{ x: 100, duration: 250 }}" out:slide="{{ x: 100, duration: 250 }}"
>
    <div class="profile-row">
        <div class="initials-block flex-center">
            {getUserInitials(user.name)}
        </div>

        <div class="info-block">
            <div class="name ellipsis">{user.name}</div>
            <div class="username ellipsis">{user.username}</div>
        </div>
    </div>

    <Separator/>

    <div class="flex-row">
        <div class="log-out" on:click={onLogOutClick}>Log Out</div>
    </div>

</div>
